<template>
  <section class="discover__section bg__black">

    <the-header
      :introDiscoveryTextProp="nextPage ? nextPage : 'Pause Journey'"
      :introDiscoveryLinkProp='nextPage ? "/benefits" : ""'
      :isCycleOnProp='isCycleOn'
      @handlePlayPause='handlePlayPause'
    >
    </the-header>

    <section class="wrapper">

      <div class="discover__accordion__wrapper">
        <section>
          <!-- Discovery Headline -->
          <div class="discover__accordion__wrapper__headline">
            <h1
              @mouseover="MX_isZoom(true)"
              @mouseleave="MX_isZoom(false)"
            >
              BurgundysCollection:
              <br>
              The Thread of Confidence
            </h1>
            <div class="progress__bar">
              <span :class="{'progress__bar--full': !isCycleOn}"></span>
            </div>
          </div>
          <!-- Accordion -->
          <div
            class="discover__accordion__wrapper__tab"
            :class="{
              'discover__accordion__wrapper__tab--interaction': !isCycleOn && isAccordionInteracted,
              'discover__accordion__wrapper__tab--iscycleon': isCycleOn
            }"
          >

            <div
              v-for="(item,i) in contents"
              :key='i'
              class="accordion__item"
              :class="{
                'accordion__item--active': item.active,
                'accordion__item--unactive-before': item.hideAfterElem
              }"
            >
              <div class="accordion__body">
                <h2
                  @mouseover="openItem(item)"
                  @mouseleave="MX_isZoom(false)"
                >
                  {{item.title}}
                </h2>
                <p
                  class="accordion__body__text"
                  @mouseover="MX_isZoom(true)"
                  @mouseleave="MX_isZoom(false)"
                >
                  {{item.desc}}
                </p>
                <section class="bg__black__overlay"></section>
              </div>
            </div>
          </div>
        </section>
       </div>
    </section>

    <next-page
      :nextPageProp="'/benefits'"
      :isCycleOnProp='isCycleOn'
    ></next-page>

    <!-- ONLY FOR DEV -->
    <!-- <div style="position: absolute; color: white; top: 10px; right: 20px; font-size: 22px;">
      <router-link to="/benefits">NEXT PAGE</router-link>
    </div> -->

  </section>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import NextPage from '@/components/VNextPage.vue'
import { isZooming } from '../mixins/isZooming'

export default {
  name: 'Discover',
  components: {
    'the-header': TheHeader,
    'next-page': NextPage
  },
  mixins: [
    isZooming
  ],
  data () {
    return {
      idOfElem: 1,
      currStatusElem: 0,
      nextStatusElem: 1,
      startPauseInterval: false,
      nextPage: '',
      isCycleOn: true,
      isAccordionInteracted: false,
      contents: [
        {
          title: 'To reward wine drinkers..',
          desc: `Exceptional wines should be protected and respected. Our members appreciate these wines have been crafted to enjoy rather than be objects of speculation.`,
          active: true,
          hideAfterElem: false,
          id: 1
        },
        {
          title: '..we support the maker',
          desc: `Every vintage contains thousands of decisions, the product of many months
           of relentless work and commitment. It is the fruit of exceptional talent. We therefore
           protect the winemakers expression by being transparent, fair and pricing honestly.`,
          active: false,
          hideAfterElem: false,
          id: 2
        },
        {
          title: '..and establish the truth',
          desc: `From merchants and critics, to speculators and distributors, everyone has their version
            of the truth about exceptional wines. We adopt the truth of the maker. It lies at the heart of all we do.`,
          active: false,
          hideAfterElem: false,
          id: 3
        },
        {
          title: '..by protecting the wine',
          desc: `Wine is magnificent, fragile, precious and alive. We offer impeccable protection for each bottle starting
            with complimentary, unlimited storage in our cellars in Burgundy and a guarantee of perfect provenance.`,
          active: false,
          hideAfterElem: false,
          id: 4
        },
        {
          title: '..with improved distribution',
          desc: `By directly connecting our members with the winemaker, we can support the best interests of one another. We share allocations fairly, by properly distributing our wines to a greater number of unique collectors.`,
          active: false,
          hideAfterElem: false,
          id: 5
        },
        {
          title: '..for a finer way of living',
          desc: `We share a philosophy based on knowledge and patience, rewarding discerning wine lovers with a private world of tales and tastings, culture and exclusivity.`,
          active: false,
          hideAfterElem: false,
          id: 6
        }
      ]
    }
  },
  mounted () {
    // this.timeBreakText = setInterval(() => this.cycleAccordion(), 7000)
    this.nextPage = 'Discover More'
    this.contents[this.currStatusElem].hideAfterElem = false
    this.isCycleOn = false
    this.$store.commit('updateCursorType', 1)
    // this.$store.commit('updateCursorType', 6)
  },
  methods: {
    // Upon finished animation, user has control to manually
    // shift through the elements
    openItem (el) {
      if (this.isCycleOn) {
        return
      }
      this.MX_isZoom(true)
      this.isAccordionInteracted = true
      this.contents.forEach(elemContents => {
        elemContents.active = false
        elemContents.hideAfterElem = false
      })
      this.idOfElem = el.id
      el.active = !el.active
    },
    cycleAccordion () {
      for (let i = 1; i <= this.contents.length; i++) {
        // TODO:
        // DISABLED FOR NOW
        // On Pause button stop the cycling
        if (this.startPauseInterval) {
          return
        }
        // Set the current element to none
        this.contents[this.currStatusElem].active = false
        this.contents[this.currStatusElem].hideAfterElem = true
        // Set the next element to visible
        this.contents[this.nextStatusElem].active = true
        // Update the state for next cycle
        this.currStatusElem++
        this.nextStatusElem++
        // Update the Rectangular element (progress bar) below headline
        this.idOfElem = this.nextStatusElem
        // On last element stop the accordion
        if (this.nextStatusElem === 6) {
          clearInterval(this.timeBreakText)
          this.nextPage = 'Discover More'
          this.contents[this.currStatusElem].hideAfterElem = false
          this.isCycleOn = false
          this.$store.commit('updateCursorType', 1)
          return
        }
        break
      }
    },
    handlePlayPause (val) {
      this.startPauseInterval = val
    }
  }
}
</script>
